export default __webpack_public_path__ + "static/media/back_to_top.207f8724.svg";